// Supplier BASIC plan limits; override via env MAX_OFFER_PER_DAY / MAX_OFFER_PER_MONTH.
export const MAX_OFFER_PER_DAY = 3 as const
export const MAX_OFFER_PER_MONTH = 12 as const
export const PREMIUM_FIRST_MONTHS_FREE = 3 as const
export const PREMIUM_PRICE_TL = 6600 as const

// Auth
export const SESSION_DAYS = 30 as const

// Upload
export const MAX_UPLOAD_SIZE_MB = 10 as const
export const MAX_CATALOG_IMAGE_SIZE_MB = 5 as const
export const MAX_PHOTOS_PER_LIST = 10 as const
export const MAX_PURCHASE_LIST_IMPORT_SIZE_MB = 10 as const
export const MAX_PURCHASE_LIST_IMPORT_ROWS = 500 as const
export const PURCHASE_LIST_IMPORT_PREVIEW_TTL_MINUTES = 60 as const

// Chat
export const MAX_MESSAGE_BODY_LENGTH = 2000 as const
export const MESSAGE_PREVIEW_LENGTH = 200 as const
export const MAX_ATTACHMENT_COUNT = 5 as const
export const MAX_CHAT_ROOMS = 100 as const
export const MAX_SSE_BATCH_SIZE = 100 as const
export const SSE_POLL_MS = 1_000 as const
export const SSE_HEARTBEAT_MS = 30_000 as const
export const SSE_RECONNECT_MS = 1_000 as const
export const MAX_SSE_PER_USER = 5 as const

// Orders
export const AUTO_COMPLETE_AFTER_DAYS = 7 as const

// Rate limits
export const RATE_LIMIT_GENERAL_PER_MIN = 60 as const
export const RATE_LIMIT_AUTH_PER_MIN = 5 as const
export const RATE_LIMIT_UPLOAD_PER_MIN = 10 as const
export const RATE_LIMIT_SSE_PER_MIN = 5 as const

// Validation
export const MIN_PASSWORD_LENGTH = 8 as const
export const PASSWORD_BCRYPT_COST = 12 as const

// Currencies
export const CURRENCY_CODE = 'TRY' as const
export const LOCALE = 'tr-TR' as const
export const TIMEZONE = 'Europe/Istanbul' as const
